/*
* Copyright © 2019 Insticator, Inc. All Rights Reserved.
*
* CONFIDENTIALITY NOTICE: THIS SOFTWARE CONTAINS CONFIDENTIAL INFORMATION OF
* INSTICATOR, INC. USE, DISCLOSURE OR REPRODUCTION IS PROHIBITED WITHOUT THE PRIOR
* EXPRESS WRITTEN PERMISSION OF INSTICATOR, INC.
*/

/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import InputType from 'components/shared/questionset/input/input';
import SelectType from 'components/content/shared/questionset/select/select_container';
import Text1Type from 'components/content/shared/questionset/text1/text1';
import Text2Type from 'components/content/shared/questionset/text2/text2';
import Image1Type from 'components/content/shared/questionset/image1/image1';
import Image2Type from 'components/content/shared/questionset/image2/image2';
import EmojiType from 'components/content/shared/questionset/emoji/emoji';
import InputSet from 'components/content/shared/questionset/input/input_container'
import Skip from 'components/shared/skip/skip_container';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/content/shared/questionset/questionset_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:true});

/* ========== ~~~~~~~~~~ QUESTION SET ~~~~~~~~~~ ========== */
const QuestionSet = props => {
    const getTimesQuestionAnswered = () => {
        let timesQuestionAnswered = 0;
        Object.values(props.frameStatus[props.frame].options).forEach(answer => {
            timesQuestionAnswered += answer.numOfTimesChosen;
        });
        return timesQuestionAnswered;
    };
    const getPercentageAnsweredDataAndCoefficient = () => {
        let total = 0;
        let highestValue = {id: null, value: 0};
        const percentageAnsweredData = {};
        const timesQuestionAnswered = getTimesQuestionAnswered();
        Object.entries(props.frameStatus[props.frame].options).forEach(([optionId, option]) => {
            let percentageAnswered = option.numOfTimesChosen === 0 ? 0 : Math.floor((option.numOfTimesChosen / timesQuestionAnswered) * 100);
            percentageAnsweredData[optionId] = percentageAnswered >= 0 ? percentageAnswered : 1;
            total += percentageAnsweredData[optionId];
            highestValue = percentageAnsweredData[optionId] > highestValue.value ? { id: optionId, value: percentageAnsweredData[optionId] } : highestValue;
        });
        if (!!highestValue.id) percentageAnsweredData[highestValue.id] = percentageAnsweredData[highestValue.id] + 100 - total;
        const barCoefficient = !!highestValue.value ? 0.9 * 100 / highestValue.value : 0;
        return { percentageAnsweredData, barCoefficient };
    };
    const answersNums = getPercentageAnsweredDataAndCoefficient();
    const displayQuestionType = () => {
        switch (props.frameData.question.type) {
            case 'text1':
                return <Text1Type data={props} percentageAnsweredData={answersNums.percentageAnsweredData} barCoefficient={answersNums.barCoefficient} contentType={props.contentType} hasRewardsComponent={props.hasRewardsComponent} />;
            case 'text2':
                return <Text2Type data={props} percentageAnsweredData={answersNums.percentageAnsweredData} barCoefficient={answersNums.barCoefficient} contentType={props.contentType} hasRewardsComponent={props.hasRewardsComponent} />;
            case 'image1':
                return <Image1Type data={props} percentageAnsweredData={answersNums.percentageAnsweredData} barCoefficient={answersNums.barCoefficient} contentType={props.contentType} hasRewardsComponent={props.hasRewardsComponent} />;
            case 'image2':
                return <Image2Type data={props} percentageAnsweredData={answersNums.percentageAnsweredData} barCoefficient={answersNums.barCoefficient} contentType={props.contentType} hasRewardsComponent={props.hasRewardsComponent} />;
            case 'emoji':
                return <EmojiType data={props} percentageAnsweredData={answersNums.percentageAnsweredData} barCoefficient={answersNums.barCoefficient} contentType={props.contentType} hasRewardsComponent={props.hasRewardsComponent} />;
            case 'select':
                return <SelectType contentId={props.contentId} data={props} percentageAnsweredData={answersNums.percentageAnsweredData} barCoefficient={answersNums.barCoefficient} contentType={props.contentType} hasRewardsComponent={props.hasRewardsComponent} />;
            case 'input':
                return <InputSet contentId={props.contentId} data={props} percentageAnsweredData={answersNums.percentageAnsweredData} barCoefficient={answersNums.barCoefficient} contentType={props.contentType} hasRewardsComponent={props.hasRewardsComponent} />;
            default:
        }
    };
    // Styles of this component depend on whether or not the rewards are enabled/permitted for the embed.
    // Sets initial values based off the rewards settings and status.
    sheet.update(props.hasRewardsComponent);
    return(
        <div className={`${sheet.classes.questionset}`}>
            {displayQuestionType()}
            {/*{true &&*/}
                {/*<Skip contentId={props.contentId}*/}
                      {/*disabled={false}*/}
                      {/*hidden={props.frameStatus[props.frame]['state'] !== 'initial'}*/}
                {/*/>}*/}
        </div>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default QuestionSet;
